import React from 'react';
import { Card } from '../ui/Card';
import { SeverityIndicator } from '../ui/SeverityIndicator';
interface ReportRating {
  reportId: string;
  reportType: string;
  descriptionAccuracy: number;
  photoAccuracy: number;
  actualSeverity: number;
}
interface ReportRatingCardProps {
  reportType: string;
  rating: Omit<ReportRating, 'reportId' | 'reportType'>;
  onChange: (field: keyof Omit<ReportRating, 'reportId' | 'reportType'>, value: number) => void;
}
export function ReportRatingCard({
  reportType,
  rating,
  onChange
}: ReportRatingCardProps) {
  return <Card className="p-6" data-id="element-231">
      <div className="mb-6" data-id="element-232">
        <p className="text-sm font-semibold text-gray-500 uppercase tracking-wider" data-id="element-233">
          Valutazione Segnalazione
        </p>
        <p className="text-xl font-bold text-navy mt-2" data-id="element-234">{reportType}</p>
      </div>

      <div className="space-y-6" data-id="element-235">
        <SeverityIndicator label="Accuratezza descrizione" value={rating.descriptionAccuracy} onChange={value => onChange('descriptionAccuracy', value)} showLabel={false} data-id="element-236" />

        <SeverityIndicator label="Accuratezza foto" value={rating.photoAccuracy} onChange={value => onChange('photoAccuracy', value)} showLabel={false} data-id="element-237" />

        <SeverityIndicator label="Gravità effettiva" value={rating.actualSeverity} onChange={value => onChange('actualSeverity', value)} showLabel={true} data-id="element-238" />
      </div>
    </Card>;
}